module.exports = __webpack_public_path__ + "assets/img/wB6cGD8eVBF96EJA.740bfddf.png";